import actions from '../actions';
import { put, takeLatest } from 'redux-saga/effects';
import { getServiceProvider, IServiceProvider } from '../../../services';

const fetchPrivateUserSaga = takeLatest(actions.fetchPrivateUser.request.type, function* () {
  const serviceProvider: IServiceProvider = yield getServiceProvider();

  try {
    const privateUser = yield serviceProvider.api.fetchPrivateUser();
    yield put(actions.fetchPrivateUser.success(privateUser));
  } catch (e) {
    yield put(actions.fetchPrivateUser.failure(e));
    serviceProvider.analyticsService.logError(e);
  }
});

const sagas = [fetchPrivateUserSaga];

export default sagas;
